import { defineStore } from 'pinia';
import { MSG_SEND_STATUS } from '@/lib/const';
import { getNotTopIndex, getChatListByListType, dealQuickList } from '@/lib/helpers/chat';
import { SocketMsgInterface } from '@/lib/typings';
import { checkSessionInGroup, extractEmailOrPhone } from '@/lib/utils';
interface ChatStore {
  sendingChatQueue: Array<string>;
  waitingQueue: Array<{
    id: string | number;
    acceptedTime: string;
  }>;
  [propsName: string]: any;
}
export const chatStore = defineStore('chatStore', {
  state: () => {
    const state: ChatStore = {
      imStatus: '斷開', // IM链接状态
      clientStatus: '前台', // 客户端状态：前台/后台
      networkStatus: '', // 网络状态
      accessSessionParams: {}, // 记录最后一个发起接入的会话参数
      currentInputContent: '',
      //发送中的消息队列
      sendingChatQueue: [],
      // 发送失败的消息队列 {id:'',reason:''}
      failedChatQueue: [],
      // 待接待队列，该队列中的会话将进行提示，回复对话后，删除队列中的对应会话
      waitingQueue: [],
      // 发送消息失败计时器（5秒内没有接收到 SendUserMsg/NewUserMsg 算发送失败）content_id区分
      msgSendMsgFailedQueue: [],
      // 快捷回复列表
      quickReplyList: [],
      quickReplyListLoading: false,
      currentActiveChatListFrom: 'personal',
      //当前展示聊天室的相关信息
      currentChatRoomInfo: {
        // 接待id
        id: '',
        // 房间来源  接待中或者同事的对话
        roomFrom: 'personal',
        //房间类型 公号 企微私聊 企微群聊 H5/APP 微信客服
        roomType: '',
        sessionId: '',
        groupId: '',
        nickName: '',
        remark: '',
        uid: '',
        isTop: false,
        members: [],
        isGroup: false,
      },
      // 是否显示滚动到底部
      showScrollToBottom: false,
      // 当前聊天室的成员
      currentChatRoomMembers: [],
      //当前展示聊天室的消息列表
      currentChatRoomMsgList: [],
      //当前展示聊天时的AI助手消息列表
      currentChatRoomAIMsgList: [],
      // AI助手指令列表
      aiAssistantInstruction: [],
      // AI助手-营销心理
      aiAssistantMarketInfo: {
        // 剩余回答次数
        remaining: 0,
        market_id: '',
        // 是否发送了聊天记录
        is_sended_history: false,
      },
      // 历史会话聊天列表
      currentHistoryChatList: [],
      //当前聊天列表  列表返回is_append：打标签但超过接待列表的接待显示时间范围
      currentChatList: {
        personal: {
          groupName: '接待中',
          msgItems: [],
        },
        team: {
          groupName: '同事的對話',
          msgItems: [],
        },
        robot: {
          groupName: '機器人',
          msgItems: [],
        },
      },
      // 当前聊天列表是否初始化加载
      currentChatListLoaded: false,
      // 当前消息分组排序类型 1-最新消息时间排序 2-消息类型排序(提醒-未处理-已处理，最新消息时间降序)
      messageSortType: 1,

      currentQuoteInfo: {
        msgType: '',
        content: '',
        quoteMsgId: '',
      },
      // 当前公海池待分配用户聊天室的相关信息
      currentSeaspoolChatRoomInfo: {
        nickname: '',
        id: '',
        uid: '',
        pool_id: '',
        robot: {},
        customer_service: {},
        is_group: false,
        group_id: '',
      },
      // 内部消息
      isInternalMsg: false,
      // 消息提醒定位会话下发内容
      notificationMessageInfo: null,
      // 用户是否被拉黑
      userIsBlack: false,
      roomInfoCache: null,
      cardItemFrom: '',
      // 当前最新消息AI回复话术
      currentChatRoomAISpeechInfo: {
        source: 1, // 1小问 2小机
        list: [],
        source_msg: {},
        showRecommedSpeech: 0,
        selectedRecommendSource: '', // 选中回答来源
      },
      // 推荐话术
      showRecommendSpeechType: 0, // 0不推荐 1子问推荐 2自然推荐
      currentPlayVoice: 0,
      receiveLabelList: [], // 会话标签列表 type 0个人 1团队
      currentLabelGroupKey: 'message', // 当前会话分组
      interveneSessionInfo: null, // 介入会话
      batchCloseProgressInfo: {
        release: 0, // 剩余条数
        total: 0,
        failed_num: 0, // 失败条数
        show: false,
      },
      // 聊天室右侧缓存
      currentChatRoomRightCache: {},
      isHistoryChecked: false, // 选择聊天记录
      // 聊天语言
      chatLanguage: {
        source: 'zh',
        target: 'en',
      },
    };
    return state;
  },
  getters: {},
  actions: {
    setImStatus(v: string) {
      this.imStatus = v;
    },
    setClientStatus(v: string) {
      this.clientStatus = v;
    },
    updateNetWorkStatus(v: string) {
      this.networkStatus = v;
    },
    setAccessSessionParams(v: any) {
      this.accessSessionParams = v;
    },
    setCurrentPlayVoice(v: any) {
      this.currentPlayVoice = v;
    },
    setUserIsBlack(v: Boolean) {
      this.userIsBlack = v;
    },
    setChatListItemCloseCheckes(id: number, listType = 'personal') {
      let tmp = getChatListByListType(listType);
      let obj = tmp.find((item: any) => item.id == id) || {};
      if (obj.id) {
        obj.close_checked = !obj.close_checked;
      }
    },
    setChatListItemCloseAddChecked({
      checked = false,
      type = 'message',
      chatListType = 'personal',
      batchType = '',
      msgIds = [],
    }: {
      checked: boolean;
      type: string;
      chatListType: 'personal' | 'team' | string;
      batchType?: string;
      msgIds?: Array<number>;
    }) {
      let tmp = getChatListByListType(chatListType);
      if (!tmp.length) return;
      for (let i = 0; i < tmp.length; i++) {
        if (msgIds.length ? msgIds.includes(tmp[i].id) : true) {
          if (tmp[i].is_top || (batchType === 'online' && tmp[i].group_id)) {
            tmp[i].close_checked = false;
          } else {
            tmp[i].close_checked = checkSessionInGroup(tmp[i], type) ? checked : false;
          }
        } else {
          tmp[i].close_checked = false;
        }
      }
    },
    setCurrentSeaspoolChatRoomInfo(info: {}) {
      this.currentSeaspoolChatRoomInfo = {
        ...this.currentSeaspoolChatRoomInfo,
        ...info,
      };
    },
    clearCurrentSeaspoolChatRoomInfo() {
      this.currentSeaspoolChatRoomInfo = {
        nickname: '',
        id: '',
        uid: '',
        pool_id: '',
        robot: {},
        customer_service: {},
        is_group: false,
        group_id: '',
      };
    },

    setCurrentActiveChatListFrom(v: string) {
      this.currentActiveChatListFrom = v;
    },
    setChatList(groupType: string, list: Array<any>) {
      const target = this.currentChatList;
      target[groupType].msgItems = list;
    },
    clearChatList() {
      this.currentChatList.personal.msgItems = [];
      this.currentChatList.team.msgItems = [];
    },
    // 改变内容以及顺序，在接受新消息的时候使用
    updateChatList(listFrom: string = 'personal', item: any) {
      const list = getChatListByListType(listFrom);
      const origin = list.find((i: any) => (item.group_id ? item.group_id === i.group_id : i.id === item.id));
      item = {
        ...origin,
        ...item,
      };
      const index = list.findIndex((i: any) => (item.group_id ? i.group_id === item.group_id : i.id === item.id));
      // 只按时间排序
      if (item.action === 'mark') {
        list.splice(index, 1, item);
      } else {
        index !== -1 && list?.splice(index, 1);
        // 改变顺序-根据排序模式来
        let idx = 0;
        if (this.messageSortType === 2) {
          let noticeSessionList = list.filter((v) => v.user_notice_num) || [];
          if (item.user_notice_num) {
            idx = noticeSessionList?.findIndex((v) => v.created_at < item.created_at);
          } else if (item.begin_wait_time) {
            let warnTimeSessionList = list.filter((v) => !v.user_notice_num && v.begin_wait_time) || [];
            idx = noticeSessionList.length + warnTimeSessionList.findIndex((v) => v.created_at < item.created_at);
          } else {
            idx = list.findIndex((v) => !v.user_notice_num && !v.begin_wait_time && v.created_at < item.created_at);
          }
        } else {
          idx = list.findIndex((v) => v.created_at < item.created_at);
        }
        idx = idx === -1 ? 0 : idx;
        list?.splice(idx, 0, item);
      }
    },
    // 只改变内容不改变顺序，在接入的时候使用
    updateChatListContent(item: any, listFrom = 'personal') {
      const list = getChatListByListType(listFrom);
      const origin = list.find((i: any) => (item.group_id ? i.group_id === item.group_id : i.id === item.id));
      const index = list.findIndex((i: any) => (item.group_id ? i.group_id === item.group_id : i.id === item.id));
      item = {
        ...origin,
        ...item,
      };
      list[index] = item;
    },
    // 批量关闭-先隐藏
    closeSessionByReceiveIds(receive_ids = [], show = false) {
      this.currentChatList.personal.msgItems?.forEach((v) => {
        receive_ids.includes(v.id) && (v.batch_close_hidden = show);
      });
    },
    setCurrentQuoteInfo(msgType: string = '', content: string = '', quoteMsgId = '') {
      this.currentQuoteInfo = {
        msgType,
        content,
        quoteMsgId,
      };
    },
    clearCurrentQuoteInfo() {
      const list = getChatListByListType(this.currentChatRoomInfo.roomFrom);
      const target = list.find((i: any) => i.id === this.currentChatRoomInfo.id);
      if (target) {
        target.draftQuote = null;
      }
      this.currentQuoteInfo = {
        msgType: '',
        content: '',
        quoteMsgId: '',
      };
    },

    setShowScrollToBottom(v: Boolean) {
      this.showScrollToBottom = v;
    },

    clearCurrentChatRoomMsgList() {
      this.currentChatRoomMsgList = [];
    },
    delMsgFromCurrentChatRoomMsgList(id: string | number) {
      const index = this.currentChatRoomMsgList.findIndex((i: any) => i?.data?.id == id);
      // 群聊标记删除，单聊移除消息
      if (this.currentChatRoomInfo.groupId) {
        index !== -1 && (this.currentChatRoomMsgList[index].data.status = 3);
      } else {
        index !== -1 && this.currentChatRoomMsgList.splice(index, 1);
      }
      return index;
    },
    updateMsgListExtra(id = 0, extra: any) {
      const target = this.currentChatRoomMsgList.find((i: any) => i?.data?.id === id);
      target && (target.data.extra = extra);
    },
    updateMsgListContent(id = 0, msg = { text: '' }) {
      const target = this.currentChatRoomMsgList.find((i: any) => i?.data?.id === id);
      target && (target.data.text = msg.text);
    },
    updateMsgListTranslation(id = 0, text: string) {
      const target = this.currentChatRoomMsgList.find((i: any) => i?.data?.id === id);
      target && (target.data.translation = text);
    },
    updateMsgListStatus(msg_id = 0, status: number) {
      const target = this.currentChatRoomMsgList.find((i: any) => i?.data?.id === msg_id);
      target && (target.data.status = status);
    },
    updateCurrentChatRoomMsgList(list: Array<any> = [], format = false, addWay = 'unshift') {
      if (Array.isArray(list) && list.length > 0) {
        list.reverse();
        // 统一格式与实时发送消息体一致
        if (format) {
          list = list.map((i) => {
            return {
              data: i,
            };
          });
        }
        // 插入标记数据结构
        list.forEach((item) => {
          // 修改撤回后展示的内容
          if (item.data.status === 3) {
            item.data.text = item.data.text.replace(/^.*(?=撤回了一条消息)/, '你');
          }
          // 客户消息是邮箱或手机号时的绑定信息
          let contactInformationBindText = null;
          if (!item.data.is_me) {
            const text = extractEmailOrPhone(item.data.text);
            if (text) {
              contactInformationBindText = text;
            }
          }

          if (item.data.extra) {
            item.data.extra.dm = {
              ...item.data.extra.dm,
              isEdit: false,
              isSlotEdit: false,
              isEditLabelMark: false,
              had_mark: !!item.data.extra.dm?.mark,
              top: 0,
              contactInformationBindText,
            };
          } else {
            item.data.extra = {
              dm: {
                isEdit: false,
                isSlotEdit: false,
                isEditLabelMark: false,
                mark: '',
                slot: {},
                top: 0,
                had_mark: false,
                contactInformationBindText,
              },
            };
          }
        });
        // addWay 区分插入方式
        if (addWay === 'push') {
          this.currentChatRoomMsgList = [...this.currentChatRoomMsgList, ...list];
        } else {
          this.currentChatRoomMsgList = [...list, ...this.currentChatRoomMsgList];
        }
      }
    },
    updateCurrentChatRoomAIMsgList(list: Array<any> = [], format = false, addWay = 'unshift') {
      if (Array.isArray(list) && list.length > 0) {
        list.reverse();
        if (format) {
          list = list.map((v) => {
            return {
              data: v,
            };
          });
        }
        // 区分指令内容消息
        list.forEach((v) => {
          if (v.data?.bazijingpi || v.data?.taisui || v.data?.shoushengzhai || v.data?.wenxiansheng) {
            v.data.is_aiAssistant_msg = true;
          }
        });
        if (addWay === 'push') {
          this.currentChatRoomAIMsgList = [...this.currentChatRoomAIMsgList, ...list];
        } else {
          this.currentChatRoomAIMsgList = [...list, ...this.currentChatRoomAIMsgList];
        }
      }
    },
    setMsgId(content_id: string | number, msg_id: string | number, status: number) {
      const target = this.currentChatRoomMsgList.find((i: any) => i?.data?.content_id == content_id);
      target && !target.data.msg_id && (target.data.msg_id = msg_id);
      // 修改消息发送状态
      target?.data && (target.data.status = status);
      // 有消息回调，修改发送预览状态
      target && (target.is_send_preview = status == 2);
    },
    setCurrentChatRoomInfo(info: {}) {
      this.currentChatRoomInfo = {
        ...this.currentChatRoomInfo,
        ...info,
      };
    },
    setChatListItemFinishMark(id: number) {
      let obj = this.currentHistoryChatList.find((item: any) => item.id == id) || {};
      if (obj.id) {
        obj.mark_status = 1;
      }
    },
    updateMsgListMark(info: any, id?: number) {
      if (id) {
        let target = this.currentChatRoomMsgList.find((i: any) => i.data.id === id);
        if (target.data?.extra?.dm) {
          target.data.extra.dm = {
            ...target.data.extra.dm,
            ...info,
          };
        }
      } else {
        this.currentChatRoomMsgList.forEach((i: any) => {
          if (i?.data?.extra) {
            i.data.extra.dm = {
              ...i.data.extra.dm,
              ...info[i.data.id],
            };
          } else {
            i.data.extra = {
              dm: {
                ...info[i.data.id],
              },
            };
          }
        });
      }
    },
    // 勾选聊天记录
    updateHistoryChecked(id: number) {
      if (id === -1) {
        this.currentChatRoomMsgList.forEach((v: any) => {
          v.data.chat_history_checked = false;
        });
      } else {
        const target = this.currentChatRoomMsgList.find((v: any) => v.data.id === id);
        if (target?.data?.id) {
          target.data.chat_history_checked = !target.data.chat_history_checked;
        }
      }
    },
    updateIsHistoryChecked(val?: boolean) {
      this.isHistoryChecked = val === false ? val : !this.isHistoryChecked;
      if (!this.isHistoryChecked) {
        this.updateHistoryChecked(-1);
      }
    },
    clearCurrentChatRoomInfo() {
      this.currentChatRoomInfo = {
        id: '',
        roomFrom: 'personal',
        roomType: '',
        source: '',
        sessionId: '',
        receiveId: '',
        groupId: '',
        nickName: '',
        remark: '',
        uid: '',
        isTop: false,
        members: [],
        externalUserId: '',
        robotProviderUserId: '',
        robotCorpProviderId: '',
        centerUid: '',
      };
    },
    updateSendingMsgQueue(type = MSG_SEND_STATUS['sending'], id: string, reason = '') {
      if (type === MSG_SEND_STATUS['sending']) {
        this.sendingChatQueue.push(id);
      } else if (type === MSG_SEND_STATUS['success']) {
        const index = this.sendingChatQueue.findIndex((i) => i === id);
        if (index !== -1) {
          this.sendingChatQueue.splice(index, 1);
        }
      } else {
        const index = this.sendingChatQueue.findIndex((i) => i === id);
        if (index !== -1) {
          this.sendingChatQueue.splice(index, 1);
        }
        this.failedChatQueue.push({
          id,
          reason,
        });
      }
    },
    setWaitingQueue(item: { id: string; acceptedTime: string }) {
      this.waitingQueue.push(item);
    },
    delWaitingQueue(id: string | number) {
      const index = this.waitingQueue.findIndex((i) => i.id === id);
      if (index !== -1) {
        this.waitingQueue.splice(index, 1);
      }
    },
    updateMsgReadState(session_id: number, receive_id?: number) {
      // 有接待id时要区分是否同个接待
      if (
        this.currentChatRoomInfo.sessionId == session_id &&
        (!receive_id || this.currentChatRoomInfo.receiveId == receive_id)
      ) {
        this.currentChatRoomMsgList.forEach((i: any) => {
          i.data?.extra && (i.data.extra.is_read = true);
        });
      }
    },
    updateMsgSendMsgFailedQueue(data: any) {
      if (data?.content_id && this.msgSendMsgFailedQueue?.findIndex((v) => v.content_id === data?.content_id) === -1) {
        this.msgSendMsgFailedQueue?.push(data);
      }
    },
    delMsgSendMsgFailedQueue(content_id: string) {
      let index = this.msgSendMsgFailedQueue?.findIndex((v) => v.content_id === content_id);
      if (index !== -1) {
        this.msgSendMsgFailedQueue?.splice(index, 1);
      }
    },
    setQuickReplyList(list: Array<any>) {
      this.quickReplyList = dealQuickList(list);
      window.localStorage.setItem('quickReplyList', JSON.stringify(this.quickReplyList));
    },
    setQuickReplyListLoading(bool: boolean) {
      this.quickReplyListLoading = bool;
    },
    topChatItem(id: string | number) {
      const list = getChatListByListType();
      const index = list.findIndex((i: any) => i.id === id);
      const item = list[index];
      if (item) {
        item.is_top = true;
        list.splice(index, 1, item);
      }
      // list.unshift(item);
    },
    cancelTopChatItem(id: string | number, prevId: string | number) {
      const list = getChatListByListType();
      const prevIdIndex = id === prevId ? 0 : list.findIndex((i: any) => i.id === prevId);
      const item = list.find((i: any) => i.id === id);
      const index = list.findIndex((i: any) => i.id === id);
      if (item) {
        item.is_top = false;
        list.splice(index, 1, item);
      }
      // list.splice(prevIdIndex, 0, item);
    },
    setCurrentHistoryChatList(list: Array<any>, addWay = 'new') {
      if (addWay === 'push') {
        list = list.filter((v) => !this.currentHistoryChatList?.map((i: any) => i.id).includes(v.id));
        this.currentHistoryChatList = [...this.currentHistoryChatList, ...list];
      } else {
        this.currentHistoryChatList = list;
      }
    },
    deleteChatListItem({ listFrom = 'personal', id = 0, groupId = 0 }) {
      const target = this.currentChatList;
      const list = target[listFrom].msgItems || [];
      const index = list.findIndex((i: any) => (groupId ? i.group_id === groupId : i.id === id));
      index !== -1 && list.splice(index, 1);
    },
    setIsInternalMsg() {
      this.isInternalMsg = !this.isInternalMsg;
    },
    setShowRecommedSpeechType(val = 0) {
      this.showRecommendSpeechType = val;
      this.setCurrentChatRoomAISpeechInfo({
        ...this.currentChatRoomAISpeechInfo,
        showRecommedSpeech: this.showRecommendSpeechType,
      });
      window.localStorage?.setItem('showRecommendSpeechType', this.showRecommendSpeechType);
    },
    setNotificationMessageInfo(info: SocketMsgInterface | null) {
      this.notificationMessageInfo = info;
    },
    setRoomInfoCache(obj: any) {
      this.roomInfoCache = obj;
    },
    clearRoomInfoCache() {
      this.roomInfoCache = null;
    },
    setCardItemFrom(v: string) {
      this.cardItemFrom = v;
    },
    setCurrentChatRoomAISpeechInfo(v: any) {
      this.currentChatRoomAISpeechInfo = v;
    },
    setCurrentChatListLoaded(v: boolean) {
      this.currentChatListLoaded = v;
    },
    setMessageSortType(v: number) {
      this.messageSortType = v;
    },
    setReceiveLabelList(val: any) {
      this.receiveLabelList = val || [];
    },
    setCurrentLabelGroupKey(val: string) {
      this.currentLabelGroupKey = val;
    },
    setInterveneSessionInfo(val: any) {
      this.interveneSessionInfo = val;
    },
    setBatchCloseProgressInfo(val: any) {
      this.batchCloseProgressInfo = {
        ...this.batchCloseProgressInfo,
        ...val,
      };
    },
    clearCurrentChatRoomAIMsgList() {
      this.currentChatRoomAIMsgList = [];
    },
    setAiAssistantInstruction(val: any) {
      this.aiAssistantInstruction = val || [];
    },
    setAiAssistantMarketInfo(val: any = {}) {
      this.aiAssistantMarketInfo = {
        ...this.aiAssistantMarketInfo,
        ...val,
      };
    },
    clearAiAssistantMarketInfo() {
      this.aiAssistantMarketInfo = {
        is_sended_history: false,
        market_id: '',
        remaining: 0,
      };
    },
    setCurrentChatRoomRightCache(val: any) {
      this.currentChatRoomRightCache = {
        ...this.currentChatRoomRightCache,
        ...val,
      };
    },
    setChatLanguage(val: any) {
      this.chatLanguage = {
        ...this.chatLanguage,
        ...val,
      };
      window.localStorage?.setItem('chatLanguageSetting', JSON.stringify(this.chatLanguage));
    },
  },
});
